import { Component, OnInit } from '@angular/core';
import { RoutingService } from 'src/app/order/services/internal/routing/routing.service';

@Component({
    selector: 'app-manual-analysis-proposal',
    templateUrl: './manual-analysis-proposal.component.html',
    styleUrls: ['./manual-analysis-proposal.component.scss'],
    standalone: false
})
export class ManualAnalysisProposalComponent {
  constructor(private routingService: RoutingService) {}

  public navigateToHome() {
    this.routingService.navigateToHome();
  }
}
